import {
  Box,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import { useSelector } from "react-redux";
import JobSurveyItems from "./JobSurveyItems";
import dayjs from "dayjs";

const FragilePack = ({jobViewType}:any) => {
  const { leadDetails } = useSelector((state: any) => state.lead);
  const { surveyedItems, surveyedSummary } = useSelector(
    (state: any) => state.leadSurvey,
  );

  const materials =
    surveyedItems?.list?.find((item: any) => item.name === "Materials")
      ?.items || [];

  const movingFrom = surveyedSummary?.lead?.moving_from?.[0] ?? leadDetails?.lead?.collection_address?.[0];
  const movingTo = surveyedSummary?.lead?.moving_to?.[0] ?? leadDetails?.lead?.delivery_address?.[0];
  const movingFromVolume = Array.isArray(leadDetails?.lead?.collection_address)
    ? leadDetails.lead.collection_address
    : [];
  const formatAddress = (addr: any) => {
    if (!addr) return "";

    return `${addr.building_number || ""} ${addr.street || ""}
  ${addr.town || ""}, ${addr.county || ""}, ${addr.country || ""}
  ${addr.postcode || ""}`;
  };

  // Separate by flags
  const allSurveyedItems =
    surveyedItems?.list?.map((cat: any) => cat.items).flat() || [];

  const leaveItems = allSurveyedItems
    .filter((it: any) => it.isLeave && Number(it.quantity) > 0)
    .map((it: any) => `${it.item} X ${it.quantity}`);
  const weeeItems = allSurveyedItems
    .filter((it: any) => it.isWeee && Number(it.quantity) > 0)
    .map((it: any) => `${it.item} X ${it.quantity}`);
  const custItems = allSurveyedItems
    .filter((it: any) => it.isCust && Number(it.quantity) > 0)
    .map((it: any) => `${it.item} X ${it.quantity}`);

  const totalVolumeM3 = movingFromVolume?.reduce((sum: any, item: any) => {
    let volume = Number(item.volume) || 0;

    if (item.volume_unit === "ft3") {
      volume = volume * 0.0283168; // convert ft3 → m3
    }

    return sum + volume;
  }, 0);

  return (
    <Box
      sx={{
        maxWidth: "900px",
        margin: "0 auto",
        padding: "20px",
        fontFamily: "Times New Roman",
        fontSize: "13px",
      }}
    >
      {/* HEADER */}
      <Grid container spacing={2}>
        <Grid item xs={4}>
          <Typography fontWeight={600}>FUEL:</Typography>
        </Grid>

        <Grid item xs={4} textAlign="center">
          <Typography fontWeight={600}>NAME:</Typography>
          {leadDetails?.lead?.customer_name}
        </Grid>

        <Grid item xs={4} textAlign="right">
          <Typography fontWeight={600}>TELEPHONE:</Typography>
          {leadDetails?.lead?.customer_phone}
        </Grid>
      </Grid>

      <Grid container mt={2}>
        <Grid item xs={6}>
          <Typography fontWeight={600}>JOB TYPE:</Typography>
         {jobViewType === "MATERIAL" ? "FRAGILE PACK" : "FULL PACK"}
        </Grid>

        <Grid item xs={6} textAlign="right">
          <Typography fontWeight={600}>DATE & TIME</Typography>
          {surveyedSummary?.lead?.packingOnDate
            ? dayjs(surveyedSummary?.lead?.packingOnDate)?.format("DD/MM/YYYY")
            : leadDetails?.lead?.packing_on_date
            ? dayjs(leadDetails?.lead?.packing_on_date)?.format("DD/MM/YYYY")
            : "N/A"}
        </Grid>
      </Grid>

      {/* MOVING FROM / TO */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell style={{ width: "50%" }} sx={headerCell}>
              MOVING FROM
            </TableCell>
            <TableCell style={{ width: "50%" }} sx={headerCell}>
              MOVING TO
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={cell}>
              {formatAddress(movingFrom)}
              <br />
              <b>Bedrooms:</b> {movingFrom?.house_size}
              <br />
              <b>Floors / Levels:</b> {movingFrom?.floors}
              <br />
              <b>Lift:</b> {movingFrom?.lift_availability}
              <br />
              <b>Type:</b> {movingFrom?.type}
              <br />
              <b>External Flights:</b> {movingFrom?.flight_of_stairs}
            </TableCell>

            <TableCell sx={cell}>
              {formatAddress(movingTo)}
              <br />
              <b>Bedrooms:</b> {movingTo?.house_size}
              <br />
              <b>Floors / Levels:</b> {movingTo?.floors}
              <br />
              <b>Lift:</b> {movingTo?.lift_availability}
              <br />
              <b>Type:</b> {movingTo?.type}
              <br />
              <b>External Flights:</b> {movingTo?.flight_of_stairs}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* DISMANTLE */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell} width={'50%'}>
              <b>COMPANY DISMANTLE:</b>
              <br />
              {weeeItems?.join(" | ")}
            </TableCell>

            <TableCell sx={cell} width={'50%'}>
              <b>Furniture fixtures given to customer by:</b>
              <br />
              Customer signature: __________________
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* CUSTOMER NOTES */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell} width={'100%'}>
              <b>CUSTOMER NOTES:</b>{" "} {surveyedSummary?.lead?.customerNotes}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      {/* MATERIALS */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={headerCell} colSpan={4}>
              MATERIALS REQUIRED FOR FRAGILE PACK
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={headerCell}>MATERIALS</TableCell>
            <TableCell sx={headerCell}>QUANTITY</TableCell>
            <TableCell sx={headerCell}>AMOUNT TAKEN (PLEASE NOTE)</TableCell>
            <TableCell sx={headerCell}>AMOUNT RETURNED (PLEASE NOTE)</TableCell>
          </TableRow>

          {materials.map((item: any, i: number) => (
            <TableRow key={i}>
              <TableCell sx={cell}>{item?.item}</TableCell>
              <TableCell sx={cell}>{item?.quantity}</TableCell>
              <TableCell sx={cell}></TableCell>
              <TableCell sx={cell}></TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>

      {/* SIGNATURE */}
      <Box mt={3}>
        <Typography fontStyle="italic">
          I have checked and can confirm that all my goods have been packed to
          my satisfaction.
        </Typography>

        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>Customer Signature</Typography>
          <Box sx={{ flex: 1, borderBottom: "1px solid black", marginTop: "auto" }} />
        </Box>

        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>Print</Typography>
          <Box
            sx={{ flex: 1, borderBottom: "1px solid black", marginTop: "auto" }}
          />
        </Box>

        <Box mt={1} display="flex" alignItems="center">
          <Typography mr={1}>Date</Typography>
          <Box sx={{ flex: 1, borderBottom: "1px solid black", marginTop: "auto" }} />
        </Box>
      </Box>
      <JobSurveyItems />
      {/* TOTAL VOLUME */}
      <Table sx={{ border: "1px solid black", mt: 2 }}>
        <TableBody>
          <TableRow>
            <TableCell sx={cell}>
              <b>TOTAL VOLUME: {totalVolumeM3.toFixed(2)} m3</b>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </Box>
  );
};

export default FragilePack;

const cell = {
  border: "1px solid black",
  padding: "6px",
  fontSize: "13px",
};

const headerCell = {
  border: "1px solid black",
  padding: "6px",
  fontWeight: 600,
};
